"use client";
import { NavItem } from "./components";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { NavItemProps } from "./components/navitem/navitem.types";

import classes from "./navigation.module.css";

import { DEFAULT_ROUTE, DEFAULT_ROUTE_PATHS, operationalMenu, utilityMenu } from "@/constants/routes";

const Navigation = () => {
  const pathname = usePathname();
  const [selectedPage, setSelectedPage] = useState(
    DEFAULT_ROUTE_PATHS.indexOf(pathname) !== -1
      ? DEFAULT_ROUTE
      : pathname.split("/").pop()!
  );

  const NavItemMap = (item: Pick<NavItemProps, "page" | "title" | "icon">) => (
    <NavItem
      key={item.page}
      page={item.page}
      selectedPage={selectedPage}
      setSelectedPage={setSelectedPage}
      icon={item.icon}
      text={item.title || ""}
    />
  );

  return (
    <section className={classes.container}>
      <nav className={classes.group}>{operationalMenu.map(NavItemMap)}</nav>
      <nav className={classes.group}>{utilityMenu.map(NavItemMap)}</nav>
    </section>
  );
};

export { Navigation };
